import { get } from 'lodash'
import styled from 'styled-components'

import * as cardUtilities from '@/utilities/client-components/utilities/cardUtilities'
import * as themeUtilities from '@/utilities/client-components/utilities/themeUtils'

const StyledAction = styled.button`
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  padding: 11px 0;
  text-overflow: ellipsis;
  text-align: center;
  outline: 0;
  cursor: ${({ disabled }: any) => (disabled ? 'initial' : 'pointer')};
  transition-property: box-shadow;
  transition-duration: 500ms;
  box-shadow:
    0 3px 1px -2px rgb(0 0 0 / 20%),
    0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  font-weight: ${(props: any) => props.theme.fontWeights.normal};
  font-size: ${(props: any) => props.theme.fontSizes.default}px;
  padding-left: ${(props: any) => props.theme.spacing.small}px;
  padding-right: ${(props: any) => props.theme.spacing.small}px;
  margin-right: ${(props: any) =>
    cardUtilities.getSpacingFromNumberOrName(props.theme, props.theme.actions.buttonSpacing)}px;
  margin-bottom: ${(props: any) =>
    props.orientation === 'horizontal'
      ? 0
      : cardUtilities.getSpacingFromNumberOrName(props.theme, props.theme.actions.buttonSpacing)}px;
  color: ${(props: any) =>
    props.format === 'outline' || get(props.theme, `actions.types.${props.color}.format`) === 'outline'
      ? themeUtilities.getRgbaColor(props.theme, `actions.types.${props.color}.backgroundColor`)
      : themeUtilities.getRgbaColor(props.theme, `actions.types.${props.color}.color`)};
  background: ${(props: any) => {
    if (props.format === 'outline' || get(props.theme, `actions.types.${props.color}.format`) === 'outline') {
      return 'white'
    } else {
      if (props.disabled) {
        return themeUtilities.getRgbaColor(props.theme, 'actions.types.disabled.backgroundColor')
      } else {
        return themeUtilities.getRgbaColor(props.theme, `actions.types.${props.color}.backgroundColor`)
      }
    }
  }};
  border: ${(props: any) => {
    if (props.format === 'outline' || get(props.theme, `actions.types.${props.color}.format`) === 'outline') {
      if (props.disabled) {
        return `1px solid ${themeUtilities.getRgbaColor(props.theme, 'actions.types.disabled.backgroundColor')}`
      } else {
        return `1px solid ${themeUtilities.getRgbaColor(props.theme, `actions.types.${props.color}.backgroundColor`)}`
      }
    } else {
      return 'none'
    }
  }};
  border-radius: 20px;

  &:last-child {
    margin-bottom: 0;
    margin-right: 0;
  }

  &:hover,
  &:active {
    box-shadow:
      0 5px 5px -3px rgb(0 0 0 / 20%),
      0 8px 10px 1px rgb(0 0 0 / 14%),
      0 3px 14px 2px rgb(0 0 0 / 12%);
  }
`

export default StyledAction
